import api from "@/api";
import { USER_TYPES } from "@/assets/variables/constants";
import { initExpoEmployee, initExpoEmployer, initExpoProgram } from "@/assets/variables/inits";

/** @type {import("vuex").Module} */
export const expo = {
    namespaced: true,

    state: {
        program: undefined,
        employee: undefined,
        employer: undefined,
        matchings: [],
    },

    getters: {
        _program(state) {
            return state.program?._id;
        },
        isUserHost(state, getters, rootState, rootGetters) {
            return state.program?.host?._user == rootGetters._user;
        },
        isUserEmployee(state, getters, rootState, rootGetters) {
            return (state.program?._employeeUsers || []).includes(rootGetters._user);
        },
        isUserEmployer(state, getters, rootState, rootGetters) {
            return (state.program?._employerUsers || []).includes(rootGetters._user);
        },
    },

    mutations: {
        setProgram(state, program) {
            state.program = initExpoProgram(program);
        },
        setEmployee(state, employee) {
            if (employee) employee = initExpoEmployee(employee);
            state.employee = employee;
        },
        setEmployer(state, employer) {
            if (employer) employer = initExpoEmployer(employer);
            state.employer = employer;
        },
        setMatchings(state, matchings) {
            state.matchings = matchings;
        },
        pushMatchings(state, matching) {
            const index = state.matchings.findIndex(({ _id }) => _id == matching._id);
            if (-1 < index) {
                state.matchings.splice(index, 1, matching);
            } else {
                state.matchings.push(matching);
            }
        },
    },

    actions: {
        async init({ dispatch, getters }, { _program = getters._program } = {}) {
            const program = await dispatch("getProgram", { _program });
            const employee = await dispatch("getEmployee");
            const employer = await dispatch("getEmployer");

            return { program, employee, employer };
        },

        async getProgram({ commit }, { _program }) {
            const { program } = await api.v1.expo.programs.get({ _id: _program });
            commit("setProgram", program);
            return program;
        },

        async getEmployee({ commit, getters: { _program }, rootGetters }) {
            if (!_program) return;
            switch (rootGetters.userType) {
                case USER_TYPES.PERSON.value: {
                    const { employees } = await api.v1.person.expo.employees.gets({ _program });
                    commit("setEmployee", employees[0]);
                    return employees[0];
                }
            }
        },

        async getEmployer({ commit, getters: { _program }, rootGetters }) {
            if (!_program) return;
            switch (rootGetters.userType) {
                case USER_TYPES.COMPANY.value: {
                    const { employers } = await api.v1.company.expo.employers.gets({ _program });
                    commit("setEmployer", employers[0]);
                    return employers[0];
                }
            }
        },

        async getMatchings({ commit, getters: { _program, isUserHost }, rootGetters: { userType, doesUserHaveConsoleScope } }) {
            if (!_program) return [];

            if (isUserHost || doesUserHaveConsoleScope) {
                const { matchings } = await api.v1.expo.programs.matchings.gets({ _program });
                commit("setMatchings", matchings);
                return matchings;
            }

            switch (userType) {
                case USER_TYPES.COMPANY.value: {
                    const { matchings } = await api.v1.company.expo.matchings.gets({ _program });
                    commit("setMatchings", matchings);
                    return matchings;
                }
                case USER_TYPES.PERSON.value: {
                    const { matchings } = await api.v1.person.expo.matchings.gets({ _program });
                    commit("setMatchings", matchings);
                    return matchings;
                }
            }
        },
    },
};

export default expo;
